/**
 * ContentGiftsSheet
 *
 * Opener for the content "gifts received" bottom sheet, shown to the content
 * owner from the content's gift action. Mirrors Flutter's
 * NavigationService.showContentGiftsSheet (navigation_service.dart:2099-2115),
 * which mounts ContentGiftsBottomSheet(mediaPath, coins).
 *
 * The coins header lives inside the body (ContentGiftsContent renders Flutter's
 * appBarTitle), so `title` stays empty — matching the sibling comments sheet
 * (ContentCommentsSheet.show).
 */

import { SheetService } from '@/presentation/components/common/sheet/service/SheetService';
import { ContentGiftsContent } from './ContentGiftsContent';

export interface ShowContentGiftsSheetParams {
  mediaPath: string;
  coins: number;
  container?: HTMLElement | string | null;
  screenKey?: string;
  fixedHeight?: string;
}

const show = ({
  mediaPath,
  coins,
  container,
  screenKey,
  fixedHeight = '85dvh',
}: ShowContentGiftsSheetParams) => {
  SheetService.show({
    title: '',
    content: (
      <ContentGiftsContent
        mediaPath={mediaPath}
        coins={coins}
      />
    ),
    container,
    screenKey,
    fixedHeight,
    scrollable: false,
    qaId: 'content-gifts',
  });
};

export const ContentGiftsSheet = {
  show,
};
